import { Button, ModalAlert } from "@mixitone/components";
import { AccountUser } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import clsx from "clsx";
import { ModalFormField } from "components/Forms/FormRenderers/ModalFormRenderer";
import { SessionFormController } from "components/Forms/SessionForm";
import { SettingsController } from "./SettingsController";

const SessionSettings: React.FC = () => {
  const controller = SessionFormController.use();
  const { loading } = controller.state;
  const fields = Object.values(controller.fields());

  const settingsController = SettingsController.use();
  const { updating, night, showCancelAlert, cancelling } = settingsController.state;

  if (loading) return null;

  return (
    <>
      <fieldset disabled={updating}>
        {fields.map((field) => (
          <ModalFormField key={field.name} field={field} record={night} />
        ))}

        {AccountUser.current && settingsController.night.game_sets.loaded && (
          <div
            className={clsx("mt-8 flex items-center justify-between rounded border p-3 text-sm", {
              "border-red-200 bg-red-50": settingsController.canCancel,
              "border-gray-300 bg-gray-100 opacity-50": !settingsController.canCancel,
            })}
          >
            <span>Oops, I didn't want to start this session now</span>
            <Button
              kind="danger"
              disabled={!settingsController.canCancel}
              className="text-xs"
              onClick={(event) => {
                event.preventDefault();
                settingsController.actionCancel();
              }}
            >
              Cancel session
            </Button>
          </div>
        )}
      </fieldset>

      {showCancelAlert && (
        <ModalAlert
          confirmKind="danger"
          title="Cancel session"
          message="Are you sure you want to cancel this session?"
          onConfirm={() => settingsController.actionConfirmCancelSession()}
          onCancel={() => settingsController.actionDismissCancelAlert()}
          confirmText="Yes, cancel session"
          cancelText="No"
          loading={cancelling}
        />
      )}
    </>
  );
};

export default SessionFormController.scope(ApplicationView(SessionSettings));
